// ADS MODALS
export const ADS_BALANCE = 'ads_balance';
export const ADS_WITHDRAW = 'ads_withdraw';
export const NEW_AD = 'new_ad';
export const NEW_AD_PROFILE = 'new_ad_profile';
export const NEW_AD_POST = 'new_ad_post';
export const NEW_AD_CLIP = 'new_ad_clip';
export const NEW_AD_CLIP_PREVIEW = 'new_ad_clip_preview';
export const AD_TARGETING = 'ad_targeting';
